/* Sanctified — minimal auto-crossfade hero slider.
   Progressive: with <2 slides or no JS, the first slide simply shows. */
class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.s-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.s-hero__dot'));
    if (this.slides.length < 2) return;

    this.index = 0;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.go(i);
        this.restart();
      });
    });

    // Pause auto-rotation while the pointer is over the hero.
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());

    this.start();
  }

  go(next) {
    if (next === this.index) return;
    this.slides[this.index].classList.remove('is-active');
    if (this.dots[this.index]) this.dots[this.index].setAttribute('aria-selected', 'false');
    this.index = next;
    this.slides[this.index].classList.add('is-active');
    if (this.dots[this.index]) this.dots[this.index].setAttribute('aria-selected', 'true');
  }

  start() {
    if (this.reduce || this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
    const speed = (parseFloat(this.dataset.speed) || 5) * 1000;
    this.stop();
    this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), speed);
  }

  restart() { this.stop(); this.start(); }
  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  disconnectedCallback() { this.stop(); }
}

if (!customElements.get('hero-slider')) {
  customElements.define('hero-slider', HeroSlider);
}
